import { Fragment } from "react/jsx-runtime";

type Tab = {
  value: string;
  label: string;
};

interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  setActiveTab: (value: string) => void;
}

const Tabs = ({ tabs, activeTab, setActiveTab }: TabsProps) => {
  return (
    <div className="rounded-[2.75rem] bg-tertiary-bg p-0.5 flex items-center w-full">
      {tabs.map((tab, index) => {
        const isActive = activeTab === tab.value;
        const nextIsActive = tabs[index + 1]?.value === activeTab;

        return (
          <Fragment key={tab.value}>
            <button
              className={`flex-1 shrink-0 text-[0.8125rem] leading-[1.25rem] rounded-[2.5rem] py-2.5 transition-colors ${
                isActive ? "font-semibold bg-segmented-control-active" : ""
              }`}
              onClick={() => setActiveTab(tab.value)}
            >
              {tab.label}
            </button>

            {index !== tabs.length - 1 && (
              <div
                className={`shrink-0 rounded-full w-px h-5 transition bg-divider opacity-0 ${
                  !isActive && !nextIsActive && "!opacity-100"
                }`}
              />
            )}
          </Fragment>
        );
      })}
    </div>
  );
};

export default Tabs;
